/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M23.8262 7.9758a.9965.9965 0 0 1-.6598.4251.9923.9923 0 0 1-.6014-.0858l-.1282-.0746-.7704-.4284.0001 12.5023c0 1.9601-1.5222 3.5628-3.4433 3.6789L17.9999 24h-12c-1.95 0-3.5444-1.5301-3.6599-3.4611l-.0067-.2245V7.8108l-.7702.4297a.9925.9925 0 0 1-.7298.1604.9961.9961 0 0 1-.5675-.3085l-.0922-.1166c-.2827-.417-.211-.9717.1473-1.304l.116-.0926L12 0l11.563 6.5792c.4564.3125.5743.9378.2633 1.3966Zm-8.0197 1.7487c.3905.3925.3905 1.0289 0 1.4215a.9964.9964 0 0 1-1.4142 0c-1.1715-1.1776-3.071-1.1776-4.2426 0-1.1715 1.1776-1.1715 3.0869 0 4.2645 1.1716 1.1776 3.0711 1.1776 4.2426 0a.9964.9964 0 0 1 1.4142 0c.3905.3926.3905 1.029 0 1.4215-1.9526 1.9627-5.1184 1.9627-7.071 0-1.9526-1.9627-1.9526-5.1448 0-7.1075s5.1184-1.9627 7.071 0Z"
    clipRule="evenodd"
  />,
  'MenuHomeFilled'
);
